import { render, staticRenderFns } from "./JobCardRating.vue?vue&type=template&id=c724e67a&scoped=true&"
import script from "./JobCardRating.vue?vue&type=script&lang=js&"
export * from "./JobCardRating.vue?vue&type=script&lang=js&"
import style0 from "./JobCardRating.vue?vue&type=style&index=0&id=c724e67a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c724e67a",
  null
  
)

export default component.exports